import { Controller } from '@hotwired/stimulus';
import ImgixHelper from '@frontend/app/features/ImgixHelper';

export default class extends Controller {
  connect() {
    ImgixHelper.refresh();
  }
}
